import React, { useEffect, useState } from "react";
import { Box, Grid } from "@material-ui/core";
import FormBase from "../../../../forms/FormBase";
import ReRegistrationAcademicDegreeForm, { ReRegistrationAcademicDegreeFormItem } from "../../../../forms/recadastramento/ReRegistrationAcademicDegreeForm";
import AcademicService from "../../../../services/AcademicService";
import TmpInputSelectSearchCustom from "../../../../components/tempo/TmpInputSelectSearchCustom/TmpInputSelectSearchCustom";
import TmpInputCustom, { InputMaskProps } from "../../../../components/tempo/TmpInputCustom/TmpInputCustom";
import TmpButtonCustom from "../../../../components/tempo/TmpButtonCustom/TmpButtonCustom";
import TmpTableBaseCustom, { ITableColumnsProps } from "../../../../components/tempo/TmpTableBaseCustom/TmpTableBaseCustom";

interface ReRegistrationAcademicDegreeComponentProps {
    ReRegistrationAcademicDegreeForm: ReRegistrationAcademicDegreeForm,
    onInputChange: (name: string, form: FormBase, value: any) => void
    onInserOrUpdateItem: () => void
    onEditClick: (e: ReRegistrationAcademicDegreeFormItem) => void
    onDeleteClick: (e: ReRegistrationAcademicDegreeFormItem) => void
    onCancelItem: () => void
}

export default function ReRegistrationAcademicDegreeComponent(props: ReRegistrationAcademicDegreeComponentProps) {

    const headers: ITableColumnsProps[] = [
        { title: "Título de Especialidade", align: "center", property: "Title", type: "text" },
        { title: "Instituição", align: "center", property: "Institution", type: "text" },
        { title: "Ano de conclusão", align: "center", property: "YearCompletion", type: "text" },
        { title: "Curso", align: "center", property: "Course", type: "text" },
    ]

    const [titleStateOptions, setTitleStateOptions] = useState([])

    useEffect(() => {
        AcademicService.getAllTitleOptions().then(e => setTitleStateOptions(e))
    }, []);


    return (

        <Grid container spacing={3}>

            <Grid item xs={6} sm={6}>
                <TmpInputSelectSearchCustom
                    label="Título de Especialidade"
                    name="Title"
                    id="Title"
                    placeholder="Selecione"
                    itens={titleStateOptions}
                    //mandatory={props.ReRegistrationAcademicDegreeForm.Title.Mandatory}
                    value={props.ReRegistrationAcademicDegreeForm.Title.Value}
                    onChange={(e) => {
                        props.onInputChange("Title", props.ReRegistrationAcademicDegreeForm, e.target.value);
                    }}
                    onBlur={(e) => {
                        props.onInputChange("Title", props.ReRegistrationAcademicDegreeForm, e.target.value);
                    }}
                    error={props.ReRegistrationAcademicDegreeForm.Title.HasError()}
                    helperText={props.ReRegistrationAcademicDegreeForm.Title.Error}
                />
            </Grid>

            <Grid item xs={6} sm={6}>
                <TmpInputCustom
                    id="Institution"
                    name="Institution"
                    label="Instituição"
                    maxLength={80}
                    type="text"
                    placeholder="Digite o nome da instituição"
                    mandatory={props.ReRegistrationAcademicDegreeForm.Institution.Mandatory}
                    value={props.ReRegistrationAcademicDegreeForm.Institution.Value}
                    onChange={(e) => {
                        props.onInputChange("Institution", props.ReRegistrationAcademicDegreeForm, e.target.value);
                    }}
                    onBlur={(e) => {
                        props.onInputChange("Institution", props.ReRegistrationAcademicDegreeForm, e.target.value);
                    }}
                    error={props.ReRegistrationAcademicDegreeForm.Institution.HasError()}
                    helperText={props.ReRegistrationAcademicDegreeForm.Institution.Error}
                />
            </Grid>



            <Grid item xs={6} sm={6}>
                <TmpInputCustom
                    label="Curso"
                    id="Course"
                    name="Course"
                    maxLength={100}
                    type="text"
                    placeholder="Digite o curso"
                    mandatory={props.ReRegistrationAcademicDegreeForm.Course.Mandatory}
                    value={props.ReRegistrationAcademicDegreeForm.Course.Value}
                    onChange={(e) => {
                        props.onInputChange("Course", props.ReRegistrationAcademicDegreeForm, e.target.value);
                    }}
                    onBlur={(e) => {
                        props.onInputChange("Course", props.ReRegistrationAcademicDegreeForm, e.target.value);
                    }}
                    error={props.ReRegistrationAcademicDegreeForm.Course.HasError()}
                    helperText={props.ReRegistrationAcademicDegreeForm.Course.Error}
                />
            </Grid>

            <Grid item xs={6} sm={6}>
                <TmpInputCustom
                    name="YearCompletion"
                    id="YearCompletion"
                    label="Ano de conclusão"
                    type="text"
                    maxLength={4}
                    mask={InputMaskProps.NUMERICO}
                    placeholder="Digite o ano de conclusão"
                    mandatory={props.ReRegistrationAcademicDegreeForm.YearCompletion.Mandatory}
                    value={props.ReRegistrationAcademicDegreeForm.YearCompletion.Value}
                    onChange={(e) => {
                        props.onInputChange("YearCompletion", props.ReRegistrationAcademicDegreeForm, e.target.value);
                    }}
                    onBlur={(e) => {
                        props.onInputChange("YearCompletion", props.ReRegistrationAcademicDegreeForm, e.target.value);
                    }}
                    error={props.ReRegistrationAcademicDegreeForm.YearCompletion.HasError()}
                    helperText={props.ReRegistrationAcademicDegreeForm.YearCompletion.Error}
                />
            </Grid>

            <Grid item xs={12}>
                <Box style={{ display: "flex", justifyContent: "flex-end", alignItems: "flex-end" }}>

                    {(props.ReRegistrationAcademicDegreeForm.FormItemToEdit.Id > 0 ?
                        <TmpButtonCustom id={"cancelar"} type="secondary" typeButton="button" size="sm" handleClick={props.onCancelItem}>
                            Cancelar edição título Acadêmico
                        </TmpButtonCustom>
                        : null
                    )}

                    {(props.ReRegistrationAcademicDegreeForm.FormItemToEdit.Id === 0 ?
                        <TmpButtonCustom id={"adicionar"} type="primary" typeButton="button" size="sm" handleClick={props.onInserOrUpdateItem}>
                            Adicionar título Acadêmico
                        </TmpButtonCustom>
                        :
                        <TmpButtonCustom id={"adicionar"} type="primary" typeButton="button" size="sm" handleClick={props.onInserOrUpdateItem}>
                            Salvar título Acadêmico
                        </TmpButtonCustom>
                    )}

                </Box>
            </Grid>

            <Grid item xs={12}>
                <TmpTableBaseCustom
                    columns={headers}
                    actionEditColumn={true}
                    actionDeleteColumn={true}
                    onDeleteClick={props.onDeleteClick}
                    onEditClick={props.onEditClick}
                    rows={props.ReRegistrationAcademicDegreeForm.FormItemList}
                />
            </Grid>

        </Grid>

    )

}